// Vendor Libs
import React, {useContext} from 'react';
import PropTypes from 'prop-types';

// Material UI
import {AppBar, Toolbar} from '@material-ui/core';
import {makeStyles, useTheme} from '@material-ui/core/styles';

// Contexts
import {LayoutContext} from '../../../contexts/layout-context';

const useStyles = makeStyles(theme => ({
  root: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginLeft: -8,
    marginRight: 8,
  },
  logo: {
    lineHeight: '20px',
    margin: '8px',
    fontFamily: 'logo-font',
    fontWeight: 'bold',
    color: 'green',
    fontSize: '24px',
    '&::before': {
      // eslint-disable-next-line quotes
      content: "'E'",
    },
    '&::after': {
      // eslint-disable-next-line quotes
      content: "'L'",
    },
  },
  span: {
    flexGrow: 1,
    width: '100%',
  },
}));

const createGet = (
  {clipped, navVariant, collapsible, collapsed, open, squeezed, navAnchor},
  normal,
  shrink,
  pushed,
  unsqueeze
) => () => {
  if (clipped || navAnchor !== 'left') return normal;
  if (navVariant === 'persistent' && open) {
    if (squeezed) {
      return pushed;
    }
    return unsqueeze;
  }
  if (navVariant === 'permanent') {
    if (collapsible) {
      if (collapsed) return shrink;
      return pushed;
    }
    return pushed;
  }
  return normal;
};

const Header = ({className, children, style, toolbarProps, ...props}) => {
  const classes = useStyles();
  const theme = useTheme();
  const layoutContext = useContext(LayoutContext);
  const {clipped, collapsedWidth, navWidth, headerPosition} = layoutContext;
  const getWidth = createGet(
    layoutContext,
    '100%',
    `calc(100% - ${collapsedWidth}px)`,
    `calc(100% - ${navWidth}px)`,
    '100%'
  );
  const getMargin = createGet(layoutContext, 0, collapsedWidth, navWidth, navWidth);

  return (
    <AppBar
      color="default"
      elevation={0}
      {...props}
      className={`${className} ${classes.root}`}
      position={headerPosition}
      style={{
        ...style,
        zIndex: clipped ? theme.zIndex.drawer + 1 : theme.zIndex.appBar,
        width: getWidth(),
        marginLeft: getMargin(),
        boxShadow: '0 5px 4px -4px #8a8987',
      }}
    >
      <Toolbar {...toolbarProps} style={{lineHeight: '20px', minHeight: '0'}}>
        <div className={classes.logo}>ar</div>
        {typeof children === 'function' ? children(layoutContext) : children}
        <span className={classes.span} />
      </Toolbar>
    </AppBar>
  );
};

Header.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  className: PropTypes.string,
  position: PropTypes.string,
  style: PropTypes.shape({}),
  toolbarProps: PropTypes.shape({}),
};

Header.defaultProps = {
  className: '',
  style: {},
  position: 'sticky',
  toolbarProps: {},
};

export default Header;
